/*------------------------------SIDEBAR-CONTENT-LIST-ACTIVE------------------------------------- */
export const makeActiveContent = () =>{
    function subtitleActive(headerSelector, item, activeClass) {
		if($(headerSelector).length === 0) return;
		$(headerSelector).each(
			function (i){
				if ($(this).offset().top - 70 <=  $(document).scrollTop()) {
					$(`${item}.${activeClass}`).removeClass(activeClass);
					$(item).eq(i).addClass(activeClass);
				}
			}
		);
	}
	$(document).scroll(function () {
		subtitleActive(".content-text>h2", ".sidebar-content ul>li", "active");
	}).scroll();
	const item = document.querySelector(".sidebar-content ul>li");
	if(item) item.classList.add("active"); //add class 'active' to first list item
};